module.exports = __webpack_public_path__ + "static/media/Chit.f2bf9a5a.png";